<!-- <ng-container>
  <nz-date-picker
    [ngModel]="value"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="writeValue($event)"
    [nzDisabled]="disabled"
    [disabled]="disabled"
    style="width: 100%"
    (blur)="onFieldBlur($event)"
  ></nz-date-picker>
</ng-container> -->

<ng-container>
  <nz-date-picker
    [(ngModel)]="value"
    [ngModelOptions]="{ standalone: true }"
    [nzDisabled]="disabled"
    style="width: 100%"
    (ngModelChange)="onDateChange($event)"
    (blur)="onFieldBlur($event)"
  ></nz-date-picker>
</ng-container>
